<template>
  <div class="servicetable">
    <div class="tablemain">
      <h3>智能合约 <br />安全审计项目列表</h3>
      <el-table
        :data="tableData"
        :span-method="arraySpanMethod"
        border
        style="width: 100%"
      >
        <el-table-column prop="code" label="序号" align="center" width="229" />
        <el-table-column
          prop="largeclass"
          align="center"
          label="审计大类"
          width="485"
        />
        <el-table-column
          prop="lubclass"
          align="center"
          label="审计小类"
          width="486"
        />
      </el-table>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";

const tableData = ref([
  {
    code: 1,
    largeclass: "一处审计",
    lubclass: "-",
  },
  {
    code: 2,
    largeclass: "条件竞争审计",
    lubclass: "-",
  },
  {
    code: 3,
    largeclass: "权限漏洞审计",
    lubclass: "访问控制审计",
  },
  {
    code: 3,
    largeclass: "权限漏洞审计",
    lubclass: "权限过大审计",
  },
  {
    code: 4,
    largeclass: "安全设计审计",
    lubclass: "外部模块使用安全审计",
  },
  {
    code: 4,
    largeclass: "安全设计审计",
    lubclass: "编译器版本安全审计",
  },
  {
    code: 4,
    largeclass: "安全设计审计",
    lubclass: "硬编码地址安全审计",
  },
  {
    code: 4,
    largeclass: "安全设计审计",
    lubclass: "fallback函数使用安全审计",
  },
  {
    code: 4,
    largeclass: "安全设计审计",
    lubclass: "显现编码安全审计",
  },
  {
    code: 4,
    largeclass: "安全设计审计",
    lubclass: "函数返回值安全审计",
  },
  {
    code: 4,
    largeclass: "安全设计审计",
    lubclass: "低级调用安全审计",
  },
  {
    code: 5,
    largeclass: "拒绝服务审计",
    lubclass: "-",
  },
  {
    code: 6,
    largeclass: "Gas优化审计",
    lubclass: "-",
  },
  {
    code: 7,
    largeclass: "设计逻辑审计",
    lubclass: "-",
  },
  {
    code: 8,
    largeclass: "“假充值”漏洞审计",
    lubclass: "-",
  },
  {
    code: 9,
    largeclass: "恶意Event事件日志审计",
    lubclass: "-",
  },
  {
    code: 10,
    largeclass: "变量声明及作用域审计",
    lubclass: "-",
  },
  {
    code: 11,
    largeclass: "重放共计审计",
    lubclass: "ECDSA签名重放审计",
  },
  {
    code: 12,
    largeclass: "未初始化的存储指针审计",
    lubclass: "-",
  },
  {
    code: 13,
    largeclass: "算术精度误差审计",
    lubclass: "-",
  },
  {
    code: 14,
    largeclass: "代币隐私性审计",
    lubclass: "-",
  },
]);
const mergeObj = reactive({});
const mergeArr = ["code", "largeclass", "lubclass"];
onMounted(() => {
  getSpanArr(tableData.value);
});
const getSpanArr = (data) => {
  mergeArr.forEach((key, index1) => {
    let count = 0; // 用来记录需要合并行的起始位置
    mergeObj[key] = []; // 记录每一列的合并信息
    data.forEach((item, index) => {
      // index == 0表示数据为第一行，直接 push 一个 1
      if (index === 0) {
        mergeObj[key].push(1);
      } else {
        // 判断当前行是否与上一行其值相等 如果相等 在 count 记录的位置其值 +1 表示当前行需要合并 并push 一个 0 作为占位
        if (item[key] === data[index - 1][key] && item[key] !== "-") {
          mergeObj[key][count] += 1;
          mergeObj[key].push(0);
        } else {
          // 如果当前行和上一行其值不相等
          count = index; // 记录当前位置
          mergeObj[key].push(1); // 重新push 一个 1
        }
      }
    });
  });
};
const arraySpanMethod = ({ row, column, rowIndex, columnIndex }) => {
  if (mergeArr.indexOf(column.property) !== -1) {
    // 判断其值是不是为0
    if (mergeObj[column.property][rowIndex]) {
      return [mergeObj[column.property][rowIndex], 1];
    } else {
      // 如果为0则为需要合并的行
      return [0, 0];
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
}
@media screen and (min-width: 769px) and (max-width: 1200px) {
}
@media screen and (min-width: 1201px) and (max-width: 2600px) {
  .servicetable {
    width: 100%;
    height: 1371px;
    background: var(--web-color-text-white, #fff);
    border-radius: 3% 3% 0 0;
    margin-top: -154px;
    padding-top: 59px;
    box-sizing: border-box;
    .tablemain {
      width: 1205px;
      margin: 0 auto;
      height: 100%;
      box-sizing: border-box;
      h3 {
        color: var(--Gray-1, #333);
        text-align: center;
        font-family: PingFang SC;
        font-size: 48px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin: 0 0 58px 0;
      }
      :deep(.el-table) {
        border-radius: 0.8%;
        stroke-width: 1px;
        stroke: #e0e7f1;
        border: 1px solid #e0e7f1;
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }
      /* 单数行 */
      :deep(.el-table__row:nth-child(odd)) {
        background: var(--web-color-text-white, #fff);
        color: var(--Gray-1, #333);
        height: 48px;
      }

      /* 双数行 */
      :deep(.el-table__row:nth-child(even)) {
        background: #f3f7fd;
        color: var(--Gray-1, #333);
        height: 48px;
      }
      :deep(.el-table th, .el-table tr) {
        background: #f3f7fd;
        color: var(--Gray-3, #828282);
        height: 48px;
      }
    }
  }
}
</style>
